export const addressSeries = [
    {
        "title": "全部",
        "value": "",
        "active": true
    },
    {
        "title": "北京",
        "value": "1",
        "active": false
    },
    {
        "title": "天津",
        "value": "2",
        "active": false
    },
    {
        "title": "河北",
        "value": "3",
        "active": false
    },
    {
        "title": "山东",
        "value": "4",
        "active": false
    },
    {
        "title": "陕西",
        "value": "5",
        "active": false
    }
]

export const dataSourceSeries = [
    {
        "title": "全部",
        "value": "",
        "active": true
    },
    {
        "title": "能建",
        "value": "1",
        "active": false
    },
    {
        "title": "交建",
        "value": "2",
        "active": false
    },
    {
        "title": "京东",
        "value": "3",
        "active": false
    },
    {
        "title": "应安网",
        "value": "4",
        "active": false
    }
]

export const timeSeries = [
    {
        "title": "全部",
        "value": "",
        "active": true
    },
    {
        "title": "近一周",
        "value": "1",
        "active": false
    },
    {
        "title": "近一个月",
        "value": "2",
        "active": false
    },
    {
        "title": "近三个月",
        "value": "3",
        "active": false
    },
    {
        "title": "近半年",
        "value": "4",
        "active": false
    }
]

export const keyWordsSeries = [
    {
        "title": "全部",
        "value": "",
        "active": true
    },
    {
        "title": "车",
        "value": "1",
        "active": false
    },
    {
        "title": "消防车",
        "value": "2",
        "active": false
    },
    {
        "title": "洒水车",
        "value": "3",
        "active": false
    },
    {
        "title": "牵引车",
        "value": "4",
        "active": false
    },
    {
        "title": "自卸车",
        "value": "5",
        "active": false
    }
]

export const isTakePartSeries = [
    {
        "title": "全部",
        "value": "",
        "active": true
    },
    {
        "title": "是",
        "value": "1",
        "active": false
    },
    {
        "title": "否",
        "value": "2",
        "active": false
    }
]
export const isStatusSeries = [
    {
        "title": "全部",
        "value": "",
        "active": true
    },
    {
        "title": "是",
        "value": "0",
        "active": false
    },
    {
        "title": "否",
        "value": "1",
        "active": false
    }
]

export const noticeSeries = [
    {
        "title": "全部",
        "value": "",
        "active": true
    },
    {
        "title": "公告",
        "value": "1",
        "active": false
    },
    {
        "title": "补遗公告",
        "value": "2",
        "active": false
    },
    {
        "title": "邀请公告",
        "value": "3",
        "active": false
    },
    {
        "title": "中标公告",
        "value": "4",
        "active": false
    }
]

export const pubTimeSeries = [
    {
        "title": "全部",
        "value": "",
        "active": true
    },
    {
        "title": "近一周",
        "value": "1",
        "active": false
    },
    {
        "title": "近一个月",
        "value": "2",
        "active": false
    },
    {
        "title": "近三个月",
        "value": "3",
        "active": false
    },
    {
        "title": "近半年",
        "value": "4",
        "active": false
    }
]